import React from 'react';
import { MultiStep } from 'components/MultiStep';
import { BankIDPersonalNumber } from './components/BankIDPersonalNumber';
import { BankIDProgressInfo } from './components/BankIDProgressInfo';
import { Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { ShouldRender } from 'components/ShouldRender';

export const BankID = ({
  name,
  onInit,
  initLoading,
  initSuccess,
  error,
}) => (
  <>
    <MultiStep>
      <MultiStep.Step>
        <BankIDPersonalNumber
          onProceed={onInit}
          loading={initLoading}
          name={name}
          initSuccess={initSuccess}
        />
      </MultiStep.Step>

      <MultiStep.Step>
        <BankIDProgressInfo />
      </MultiStep.Step>
    </MultiStep>

    <ShouldRender condition={!!error}>
      <Message negative>
        <FormattedMessage id={error} />
      </Message>
    </ShouldRender>
  </>
);
